import React, { Component } from 'react';

const emojiStyle = {
    margin: '15px 0',
    border: '1px solid #ffffff',
    padding: 10,
    width: 225,
    textAlign: 'center',
    borderRadius: 5,
    color: '#ffffff',
    textDecoration: 'none',
    fontWeight: 100
};

const iconGoogle = {
    width: 100,
    height: 100,
    borderRadius: '50%',
    border: '3px solid #ffffff'
};
export default class Match extends Component {
    render() {
        return (
            <div
                style={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    opacity: 0.9,
                    background: '#000000',
                    top: 0,
                    left: 0,
                    bottom: 0,
                    zIndex: 100,
                    color: '#ffffff'
                }}
            >
                <div
                    style={{
                        margin: '0 auto',
                        display: 'flex',
                        justefyContent: 'center',
                        alignItems: 'center',
                        flexDirection: 'column'
                    }}
                >
                    <h1 style={{ fontFamily: 'Dancing Script' }}>It's a Match!</h1>
                    <p>Skicka ett mail eller ring ett samtal</p>
                    <div style={{ margin: '30px 0' }}>
                        <img style={iconGoogle} alt="like" src={require('../images/account.png')} />
                        <img
                            style={{
                                width: 35,
                                height: 'auto',
                                borderRadius: '50%'
                            }}
                            alt="super like"
                            src={require('../images/super_like.png')}
                        />
                        <img
                            style={iconGoogle}
                            alt="profile"
                            src={require('../images/profile.png')}
                        />
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', margin: '30px 0' }}>
                        <a
                            style={emojiStyle}
                            href="mailto:jeremydanner2@gmail.com?Subject=Tänk%20på%20att%20jag%20är%20nöjd%20med%20mitt%20jobb%20som%20jag%20har%20idag,%20du%20måste%20locka%20med%20något%20riktigt%20bra%20i%20så%20fall!%20😅"
                        >
                            <span role="img" aria-label="emoji">
                                📨{' '}
                            </span>Skicka ett mail
                        </a>
                        <a style={emojiStyle} href="tel:+46762281885">
                            <span role="img" aria-label="emoji">
                                📱{' '}
                            </span>Ring ett samtal
                        </a>
                    </div>
                    <div style={{ bottom: 0, position: 'absolute', width: '100%' }}>
                        <div
                            className="pointer"
                            onClick={() => this.props.action()}
                            style={{
                                margin: '15px',
                                textAlign: 'center',
                                color: '#ffffff',
                                fontWeight: 100,
                                textDecoration: 'underline',
                                fontFamily: 'Dancing Script'
                            }}
                        >
                            Stäng
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Match.js